<template>
  <ol class="text-container">
    <li v-for="(item, idx) in content" :key="idx">
      <EditorParagraphBlock
        v-for="(p, index) in item.content"
        :key="index"
        :content="p.content"
        :attrs="p.attrs"
        :editable="editable"
      >
      </EditorParagraphBlock>
    </li>
  </ol>
</template>

<script setup>
defineProps({
  editable: { type: Boolean, default: false },
  content: { type: Array, default: () => [] },
});
</script>
